function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeSelectStyles = function makeSelectStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiSelect: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          color: tokens.colors["ink-on-background"]
        }, tokens.typography["short-copy-medium"]), {}, {
          backgroundColor: tokens.colors["field-fill"],
          "& em": {
            color: tokens.colors["ink-on-background-60"],
            fontStyle: "normal"
          },
          "&[aria-expanded='true'] + input + .DhigSvgIcon--type--ui-control-icon": {
            transform: "rotate(180deg)"
          },
          "& .DhigSelect--option": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            "& + .DhigSelect--checkedIcon": {
              display: "none"
            }
          }
        }),
        outlined: {
          "&&": {
            paddingRight: primitives.spacings["3"]
          }
        },
        select: {
          minHeight: "inherit"
        }
      }
    },
    MuiNativeSelect: {
      styleOverrides: {
        select: {
          "&:hover": {
            borderBottomWidth: primitives.borderWidths.none,
            boxShadow: "0px 1px 0px 0px ".concat(tokens.colors["ink-hover"]),
            transitionTimingFunction: tokens.transitions["state-blur"].transitionTimingFunction,
            transitionDuration: tokens.transitions["state-blur"].transitionDuration
          },
          "&:focus, &:focus-visible": {
            borderBottomWidth: primitives.borderWidths.none,
            borderRadius: "".concat(primitives.borderRadii.medium, " ").concat(primitives.borderRadii.medium, " 0 0"),
            boxShadow: tokens.effects["focus-ring-thin"]
          }
        }
      }
    }
  };
};